import {AUTH_ERROR, AUTH_REQUEST, AUTH_SUCCESS, CLEAR_AUTH, SET_AUTH_TOKEN} from "../actions/auth";

const initialState = {
    authToken: null,
    currentUser: null,
    loading: false,
    error: null,
    modalOpen: false
};

export default function reducer (state = initialState, action) {
    if (action.type === SET_AUTH_TOKEN) {
        return Object.assign({}, state, {
            authToken: action.authToken
        })
    } else if (action.type === CLEAR_AUTH) {
        return Object.assign({}, state, {
            authToken: null,
            currentUser: null
        });
    } else if (action.type === AUTH_REQUEST) {
        return Object.assign({}, state, {
            loading: true,
            modalOpen: action.modalOpen,
            error: null
        });
    } else if (action.type === AUTH_SUCCESS) {
        return Object.assign({}, state, {
            loading: false,
            modalOpen: false,
            currentUser: action.currentUser
        });
    } else if (action.type === AUTH_ERROR) {
        return Object.assign({}, state, {
            loading: false,
            modalOpen: false,
            error: action.error
        });
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/authreducer.js